import { IncludedGuaranteesUI } from "./IncludedGuaranteesUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";

export function IncludedGuarantees({
  product,
}: Pick<StandardProps, "product">) {
  const { variant } = useVariant(product);
  const { services } = variant;

  if (!services || services.length === 0) {
    return null;
  }

  const guarantees = services.filter(
    ({ __typename }) => __typename === "IncludedGuarantee",
  );

  if (guarantees.length === 0) {
    return null;
  }

  return <IncludedGuaranteesUI guarantees={guarantees} />;
}
